import { getLOBs, hasActiveDevice } from './account';

export const PREACTIVE_SVG = 'https://static.cimcontent.net/common-web-assets/svg/brand-updates/devices-preactive.svg';

const INSTALL_LINK = 'https://www.xfinity.com/support/articles/how-to-install-your-self-install-kit-devices';
const CHECKLIST_LINK = 'https://www.xfinity.com/support/articles/installation-checklist%0A';
const ARRIVE_TEXT = "Once your devices arrive they'll appear here";
const ACTIVE_TEXT = "Once your devices are active they'll appear here";

// Mirrors legacy deviceController.resolveSikGet business rules.
export const getPreactiveDetails = (sikOrder = {}, account = {}) => {
  const lobs = getLOBs(account);
  const activeLobs = Object.keys(lobs).filter(lob => lobs[lob]);
  const isPluggedIn = activeLobs.some(lob => hasActiveDevice(account, lob));

  if (sikOrder.status !== 'ARRIVED') {
    return { link: INSTALL_LINK, text: ARRIVE_TEXT };
  }

  if (!isPluggedIn) {
    return { link: CHECKLIST_LINK, text: ACTIVE_TEXT };
  }

  return { text: ACTIVE_TEXT };
};
